import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE = window.location.hostname;

export const getForms = createAsyncThunk('sendiioApp/forms/getForms', async (params) => {

	let url = API_BASE === 'localhost' ?
		'http://localhost/sendiio-api/index.php/api/get_forms' :
		'https://sendiio.com/ajax/forms';

	const {startFrom, search} = params;

	if(parseInt(startFrom) > 0){
		url = `${url}?page=${startFrom}`;
		url = search !== '' ? `${url}&search=${search}` : url;
	} else {
		url = search !== '' ? `${url}?search=${search}` : url;
	}

	const response = await axios.get(url).catch((error) => {

		return {'error': 1, 'msg': error};

	});

	const data = await response.data;

	return data;

});

export const getForm = createAsyncThunk('sendiioApp/forms/getForm', async (id) => {

	const url = API_BASE === 'localhost' ? `http://localhost/sendiio-api/index.php/api/get_form/${id}` : `https://sendiio.com/ajax/forms/${id}`;

	const response = await axios.get(url).catch((error) => { return {'error': 1, 'msg': error}; });

	const data = await response.data;

	return data;

});

export const addForm = createAsyncThunk('sendiioApp/forms/addForm', async (params) => {

	const url = API_BASE === 'localhost' ? `http://localhost/sendiio-api/index.php/api/add_form` : `https://sendiio.com/forms/editor/create`;

	const response = await axios.post(url, params).catch((error) => { return {'error': 1, 'msg': error}; });

	const data = await response.data;

	return data;

});

export const updateForm = createAsyncThunk('sendiioApp/forms/updateForm', async (params) => {

	const url = API_BASE === 'localhost' ? `http://localhost/sendiio-api/index.php/api/update_form/` : `https://sendiio.com/forms/editor/edit`;

	const response = await axios.post(url, params).catch((error) => { return {'error': 1, 'msg': error}; });

	const data = await response.data;

	return data;

});

export const removeForm = createAsyncThunk('sendiioApp/forms/removeForm', async (id) => {

	const url = API_BASE === 'localhost' ? `http://localhost/sendiio-api/index.php/api/remove_form/${id}` : `https://sendiio.com/forms/${id}/delete`;

	const response = await axios.get(url).catch((error) => {
		return {'error': 1, 'msg': error};
	});

	const data = await response;

	return data;

});


export const resetCount = createAsyncThunk('sendiioApp/forms/resetCount', async (formData) => {

	const url = API_BASE === 'localhost' ? `http://localhost/sendiio-api/index.php/api/reset_count` : `https://sendiio.com/ajax/form/reset-count`;

	const response = await axios.post(url, formData).catch((error) => {
		return {'error': 1, 'msg': error};
	});

	const data = await response.data;

	return data;

});

export const addTag = createAsyncThunk('sendiioApp/user/data', async (formData) => {

	const url = API_BASE === 'localhost' ?
		`http://localhost/sendiio-api/index.php/api/new_tag` :
		`https://sendiio.com/ajax/forms/new-tag/${formData.id}`;

	const response = await axios.post(url, {name: formData.name}).catch((error) => {
		return {'error': 1, 'msg': error};
	});

	const data = await response.data;

	return data;

});